import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-one-columns-three-page',
  templateUrl: './courses-grid-style-one-columns-three-page.component.html',
  styleUrls: ['./courses-grid-style-one-columns-three-page.component.scss']
})
export class CoursesGridStyleOneColumnsThreePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
